<template>
  <asc-dialog
    :show-dialog="showDialog"
    text="Fleet Graph"
    :on-close="handleClose"
    :width="1000"
  >
    <template v-if="showDialog">
      <asc-fleet-graph
        :definition="definition"
        :loading="loading"
        :on-date-change="onDateChange"
        :dates="dates"
      ></asc-fleet-graph>
    </template>
  </asc-dialog>
</template>

<script>
import { AscDialogMixin, AscDataDefinitionMixin } from '@/components/mixins'
import AscDialog from '@/components/atoms/AscDialog'
import AscFleetGraph from './AscFleetGraph'

export default {
  name: 'AscFleetGraphDialog',

  components: {
    AscDialog,
    AscFleetGraph,
  },

  mixins: [AscDialogMixin, AscDataDefinitionMixin],

  props: {
    dates: {
      type: Object,
      default: () => {},
    },
    onDateChange: {
      type: Function,
      default: () => {},
    },
  },
}
</script>
